import React from "react";
import { EmailConfirmation } from "@features/login/components/EmailConfirmation";
import { LoginPagesLayout } from "@features/login/LoginPagesLayout";

export const EmailConfirmationPage = () => {
  return (
    <LoginPagesLayout>
      <EmailConfirmation />
    </LoginPagesLayout>
  );
};
